import SelectEditableField from 'src/components/fields/SelectEditableField/SelectEditableField';

export default SelectEditableField;
